import type { Schema } from '@biteinc/common';

export const precisionCopyMenuSectionOptionsSchema: Schema.Model = {
  displayName: 'Precision Copy Menu Section Options',
  type: 'object',
  fields: {
    createMenuItems: {
      type: 'bool',
      defaultValue: false,
      displayName: 'Create New Menu Items',
      tooltip: {
        text: 'If a menu item on this section does not exist at the target location, then it will be created. If one of the items cannot be created at a location, then the section copy will be skipped. Existing items will not be updated unless the appropriate option is selected.',
      },
    },
    updateMenuItems: {
      type: 'bool',
      defaultValue: false,
      displayName: 'Update Existing Menu Items',
      tooltip: {
        text: 'If a menu item on this section exists at the target location, then it will be updated. If one of the items cannot be updated at a location, then the section copy will be skipped. New items will not be created unless the appropriate option is selected.',
      },
    },
  },
};
